/**
 * Created by jinbian on 15/11/2017.
 */
import React from "react";
import Modal from "react-modal";
import "./_index.scss";
import {getTextByPath} from "../../utility/i18n";
import axios from "axios";

/* const */
let agreeData;

const customStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)"
    }
};
export default class extends React.Component {

    constructor() {
        super();

        //
        agreeData = window["I18N"]["agreeModal"];

        //
        this.state = {
            isScrollDown: true,
            promised: false,
            getView: this.getPolicyView,
            fileLink: "",
            policyContent: ""
        };
    }

    handleScroll = () => {
        let dom = document.getElementsByClassName("dn-agreement-modal-policy")[0];
        if (!this.state.isScrollDown && dom && ((dom.scrollHeight - dom.scrollTop - dom.clientHeight) < 5)) {
            this.setState({isScrollDown: true});
        }
    };

    handleCheck = (e) => {
        this.setState({promised: e.target.checked});
    };

    componentDidMount() {
        if (this.props.termID && this.props.state === "showPolicy") {
            axios({
                method: 'get',
                url: `${TERM_SERVICE_URL}${this.props.termID}/commits/latest`,
                withCredentials: true,
            }).then((res) => {
                this.setState({
                    termVersion: res.data.id,
                });
                axios({
                    method: 'get',
                    url: res.data.files[0].link,
                    withCredentials: true,
                }).then((contentRes) => {
                    this.setState({
                        policyContent: contentRes.data,
                    });
                });
            });
        }
    }

    render() {

        const {state} = this.props;

        let view = null;

        if (state === "success") {
            view = this.getSuccessView();
        } else if (state === "fail") {
            view = this.getFailView();
        } else if (state === "showPolicy") {
            view = this.getPolicyView();
        }

        return (
            <Modal isOpen={true} className={"dn-agreement-modal"} style={customStyles}>
                {view}
            </Modal>
        );
    }

    confirmDownload = (e) => {
        // Accept the latest version
        axios({
            method: 'post',
            url: `${TERM_SERVICE_URL}${this.props.termID}/acceptances`,
            withCredentials: true,
            data: {
                accepted_version: this.state.termVersion,
            },
        }).then((res) => {
            this.props.onConfirm();
        });
        e.preventDefault();
    };

    getPolicyView = () => {
        return <div>
            <h1>{getTextByPath(agreeData, "downLoad.agree.title")}</h1>
            <div className="dn-agreement-modal-policy" onScroll={this.handleScroll}>
                <div id="dn-policy" dangerouslySetInnerHTML={{__html: this.state.policyContent}}/>
            </div>
            <div>
                <input type="checkbox" onClick={this.handleCheck} disabled={!this.state.isScrollDown}/>
                <span
                    className={"dn-agreement-modal-commitment" + (this.state.promised ? " enable" : "")}>{getTextByPath(agreeData, "commitment")}</span>
            </div>
            <div>
                <button disabled={!this.state.promised}
                        className="button"
                        onClick={this.confirmDownload}>{getTextByPath(agreeData, "text.download")}</button>


                <button onClick={this.props.onToggle}
                        className="button secondary">{getTextByPath(agreeData, "text.cancel")}</button>
            </div>
        </div>
    };

    getSuccessView = () => {
        return <div className="dn-agreement-modal-success">
            <h1>{getTextByPath(agreeData, "downLoad.success.title")}</h1>
            <div>
                <span>
					{getTextByPath(agreeData, "downLoad.success.content.start")}
                    <a href={this.props.fileLink}
                       target="_blank">	{getTextByPath(agreeData, "downLoad.success.content.here")}</a>
                    {getTextByPath(agreeData, "downLoad.success.content.end")}
				</span>
            </div>
            <div>
                <button
                    className="button"
                    onClick={(e) => {
                        window.location.href = "/";
                    }}>{getTextByPath(agreeData, "text.close")}</button>
            </div>
        </div>;
    };

    getFailView = () => {
        return <div className="dn-agreement-modal-fail">
            <h1>{getTextByPath(agreeData, "downLoad.fail.title")}</h1>
            <div>
                {getTextByPath(agreeData, "downLoad.fail.content")}
            </div>
            <div>
                <input type="button" value={getTextByPath(agreeData, "text.close")} onClick={() => {
                    window.location.href = "/";
                }}/>
            </div>
        </div>;
    };
}
